declare const google: any;

function googleMapsInitialize(): void {
  const mapDiv = document.getElementById('locationMap');
  if (!mapDiv) {
    //console.info("Map container not found");
    return;
  }

  const rawPointsHtml = mapDiv.dataset.points || '';
  const rawPoints = rawPointsHtml;

  const defaultZoom = parseInt(mapDiv.dataset.defaultZoom || '8', 10);
  const pinZoomLevel = parseInt(mapDiv.dataset.pinZoom || '12', 10);

  let locations;
  try {
    locations = JSON.parse(rawPoints);
  } catch (err) {
    console.error("Invalid JSON in data-points:", err, rawPoints);
    return;
  }

  const parsedLocations = locations
    .map((loc: any) => ({
      lat: parseFloat(loc.lat),
      lng: parseFloat(loc.lng),
      title: loc.title,
      address: loc.address,
      url: loc.url,
      directionsUrl: loc.directionsUrl
    }))
    .filter(loc => !isNaN(loc.lat) && !isNaN(loc.lng));

  if (!parsedLocations.length) {
    console.warn("No valid map points found");
    return;
  }

  const center = {
    lat: parsedLocations[0].lat,
    lng: parsedLocations[0].lng
  };

  const map = new google.maps.Map(mapDiv, {
    center,
    zoom: defaultZoom,
    zoomControl: true,
    mapTypeControl: false,
  });

  const bounds = new google.maps.LatLngBounds();
  const infoWindow = new google.maps.InfoWindow(); // One reusable instance

  parsedLocations.forEach(pt => {
    const pos = { lat: pt.lat, lng: pt.lng };
    const marker = new google.maps.Marker({
      position: pos,
      map,
      title: pt.title
    });
    bounds.extend(pos);

    marker.addListener('click', () => {
      map.setZoom(pinZoomLevel);
      map.panTo(pos);

      const contentString = `
        <div class="row specialty-contact-info">   
          <h4><a href="${pt.url}" tabindex="0">${pt.title}</a></h4>     
          <address>${pt.address.replace(/\n/g, '<br>')}</address>   
          <p><a class="phoneLink" href="${pt.directionsUrl}" target="_blank">Directions</a></p>
        </div>
      `;

      infoWindow.setContent(contentString);
      infoWindow.open(map, marker);
    });
  });

  if (parsedLocations.length > 1) {
    map.fitBounds(bounds, 50);
  } else {
    map.fitBounds(bounds, 50);
    google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
      if (map.getZoom() > pinZoomLevel) {
        map.setZoom(pinZoomLevel);
      }
    });
  }
}

(window as any).googleMapsInitialize = googleMapsInitialize;
